import {
  ADD_DRAFT_SPOT_REVIEW,
  REMOVE_DRAFT_SPOT_REVIEW,
  ADD_DRAFT_SUB_SPOT_REVIEW,
  REMOVE_DRAFT_SUB_SPOT_REVIEW,
  ADD_SPOT_REVIEW,
  ADD_SPOT_REVIEW_COMPLETE,
  UPDATE_SPOT_REVIEW,
  DELETE_SPOT_REVIEW,
  DELETE_SPOT_REVIEW_PHOTO,
  GET_SPOTS,
  GET_SPOT_REVIEWS,
  GET_SPOT_REVIEW,
  GET_USER_REVIEWS,
} from "../types";

const SpotReviewReducer = (state, action) => {
  switch (action.type) {
    case GET_SPOTS: {
      const { items, total, page, pageSize, hasMore, append } = action.payload;
      return {
        ...state,
        spots: append ? [...state.spots, ...items] : items,
        spotsTotal: total,
        spotsPage: page,
        spotsPageSize: pageSize,
        spotsHasMore: hasMore,
        loading: false,
        spotReviewAdded: false,
      };
    }
    case GET_SPOT_REVIEW: {
      const review = action.payload;
      const exists = (state.spotReviews || []).some((r) => r.id === review.id);
      return {
        ...state,
        spotReviews: exists
          ? state.spotReviews.map((r) => (r.id === review.id ? review : r))
          : [review, ...(state.spotReviews || [])],
        loading: false,
      };
    }
    case GET_SPOT_REVIEWS: {
      const spotReviews = action.payload;
      return {
        ...state,
        spotReviews: spotReviews,
        loading: false,
        spotReviewAdded: false,
      };
    }
    case ADD_SPOT_REVIEW:
      return {
        ...state,
        spotReviews: [action.payload, ...state.spotReviews],
        loading: false,
        spotReviewAdded: true,
        message: "add_spot_review_success",
      };
    case UPDATE_SPOT_REVIEW: {
      const updated = action.payload;
      return {
        ...state,
        spotReviews: state.spotReviews.map((r) => r.id === updated.id ? updated : r),
        userReviews: state.userReviews.map((r) => r.id === updated.id ? updated : r),
        loading: false,
      };
    }
    case DELETE_SPOT_REVIEW_PHOTO: {
      const { review_id, photo_id } = action.payload;
      const removePhoto = (r) => {
        if (r.id !== review_id || !r.photos) return r;
        return { ...r, photos: r.photos.filter((p) => p.id !== photo_id) };
      };
      return {
        ...state,
        spotReviews: state.spotReviews.map(removePhoto),
        userReviews: state.userReviews.map(removePhoto),
      };
    }
    case DELETE_SPOT_REVIEW:
      return {
        ...state,
        spotReviews: state.spotReviews.filter((r) => r.id !== action.payload),
        userReviews: state.userReviews.filter((r) => r.id !== action.payload),
        userReviewsTotal: Math.max(0, (state.userReviewsTotal || 0) - 1),
        loading: false,
        message: "delete_spot_review_success",
      };
    case ADD_SPOT_REVIEW_COMPLETE:
      return {
        ...state,
        spotReviewAdded: false,
      };
    case ADD_DRAFT_SPOT_REVIEW: {
      const draft = action.payload;
      return {
        ...state,
        draftSpotReviews: [draft, ...state.draftSpotReviews],
      };
    }
    case REMOVE_DRAFT_SPOT_REVIEW:
      return {
        ...state,
        draftSpotReviews: state.draftSpotReviews.filter((_, i) => i !== action.payload),
      };
    case ADD_DRAFT_SUB_SPOT_REVIEW: {
      const { parentIndex, subReview } = action.payload;
      return {
        ...state,
        draftSpotReviews: state.draftSpotReviews.map((d, i) => {
          if (i !== parentIndex) return d;
          const subReviews = [...(d.subReviews || []), subReview];
          return { ...d, subReviews };
        }),
      };
    }
    case REMOVE_DRAFT_SUB_SPOT_REVIEW: {
      const { parentIndex, subIndex } = action.payload;
      return {
        ...state,
        draftSpotReviews: state.draftSpotReviews.map((d, i) => {
          if (i !== parentIndex) return d;
          const subReviews = (d.subReviews || []).filter((_, k) => k !== subIndex);
          return { ...d, subReviews };
        }),
      };
    }
    case GET_USER_REVIEWS: {
      const { items, total, page, pageSize, hasMore, append } = action.payload;
      return {
        ...state,
        userReviews: append ? [...state.userReviews, ...items] : items,
        userReviewsTotal: total,
        userReviewsPage: page,
        userReviewsPageSize: pageSize,
        userReviewsHasMore: hasMore,
        loading: false,
      };
    }
    default:
      return state;
  }
};

export default SpotReviewReducer;
